export default {"src":"/_next/static/media/chevron-down-circle.b218e15b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};